import { Grid, Header } from 'semantic-ui-react';
import { Table } from '~/components';
import Link from '~/components/Link';
import { usePortfolioContext } from '~/hooks';
import PortfolioSummaryTableStatus from './PortfolioSummaryTableStatus';
import { formatNumber } from '~/utils';
import { usePermissions } from '~/requests/permissions/usePermissions';
import { DealStates } from '~/constants';
import { getProjectPvSizeMWdc } from '~/utils/calculators/system';
import { calculateProjectCosts } from '~/utils/calculators';
import ManageProjectsDropdown from '~/components/PortfolioPage/ManageProjectsDropdown';

export default function PortfolioSummaryTable() {
  const { projectBlobs, portfolioState } = usePortfolioContext();
  const { permissions } = usePermissions();

  const isInvestor = !permissions.isAdmin && permissions.hasPortfolioInvestorAccess;
  const portfolioEditable = portfolioState?.latestState < DealStates.IN_DILIGENCE;
  const parentProjectBlobs = projectBlobs?.filter((projectBlob: any) => !projectBlob?.project?.parentId);
  const portfolioProjects = (isInvestor || portfolioState?.latestState >= DealStates.IN_DILIGENCE) ? projectBlobs : parentProjectBlobs;
  const projectHasStorage = portfolioProjects
    ?.map((projectWrapper: any) => projectWrapper.project)
    .some((project: any) => {
      return project?.hasStorage;
    }) as boolean;


  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between'}}>
        <Header as="h2">
          Portfolio projects
        </Header>
        {portfolioEditable && !isInvestor && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--small)' }}>
            <ManageProjectsDropdown />
          </div>
        )}
      </div>
      <div className="summary-table-container">
        <div style={{ margin: '0 auto var(--large)', overflowX: 'auto' }}>

          <Grid.Row>
            <Grid.Column>
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Project name</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">PV size (MWdc)</Table.HeaderCell>
                    {projectHasStorage && <Table.HeaderCell textAlign="center">BESS size (kW / kWh)</Table.HeaderCell>}
                    <Table.HeaderCell textAlign="center">Budget ($/Wdc)</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Offtake type</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Location</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Status</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>

                  {portfolioProjects?.map((projects: any) => {
                    const { project, projectDisplayValues } = projects;
                    let projectCosts: any;
                    if (project && project.acceptedBid) {
                      projectCosts = calculateProjectCosts(
                        project,
                        permissions,
                        { bid: project.acceptedBid }
                      );
                    } else {
                      projectCosts = calculateProjectCosts(
                        project,
                        permissions,
                        { bid: {} }
                      );
                    }

                    return (
                      <Table.Row key={project?.id}>
                        <Table.Cell>
                          <Link
                            to={`/project/${project.id}`}
                            primary
                            bold
                            underline
                          >
                            {project.name}
                          </Link>
                        </Table.Cell>
                        <Table.Cell textAlign="center">{formatNumber(getProjectPvSizeMWdc(project), 3)}</Table.Cell>
                        {projectHasStorage && <Table.Cell textAlign="center">{projectDisplayValues?.storage?.storageDisplay}</Table.Cell>}
                        <Table.Cell textAlign="center">{project.acceptedBid ? formatNumber(projectCosts?.perWdc?.total, 3) : 'TBD'}</Table.Cell>
                        <Table.Cell textAlign="center">{projectDisplayValues?.projectDetails?.offtakeRate?.deploymentType}</Table.Cell>
                        <Table.Cell textAlign="center">{projectDisplayValues?.projectDetails?.location}</Table.Cell>
                        <Table.Cell textAlign="center">
                          <PortfolioSummaryTableStatus projectBlob={projects} />
                        </Table.Cell>
                      </Table.Row>
                    );
                  })}
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </div>
      </div>
    </>
  );
}
